export function useActiveFilterColor(activeFilters, colorMap) {
  if (!activeFilters?.length) return "#ffffff";

  const last = activeFilters.at(-1);
  const key = last.includes("_") ? last.split("_")[0] : last;

  return colorMap[key] || colorMap[last] || "#ffffff";
}
